import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { ProductStore } from 'src/app/stores/product.store';
import { currencyCode, imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
})
export class ProductsComponent implements OnInit {
  @Input() productDealsSlider: boolean = false;
  @Input() product;
  imageUrl = imageUrl;
  currencyCode = currencyCode;
  is_target_audience: boolean = true;

  constructor(
    private route: Router,
    private userAuth: AuthenticationStore,
    private loaderService: LoaderService,
    private productStore: ProductStore,
    public platform: Platform
  ) {}

  product_page() {
    this.route.navigate(['/product']);
  }

  ngOnInit() {}

  // percentage off the original price, for the card badge
  get discount(): number {
    const actual = Number(this.product?.actual_price);
    const price = Number(this.product?.product_price);
    if (!actual || !price || price >= actual) return 0;
    return Math.round((1 - price / actual) * 100);
  }
  async saveUnsave(event) {
    event?.stopPropagation();
    if (this.userAuth.userInfo) {
      this.loaderService.showLoading();
      try {
        await this.productStore.saveUnsaveProduct(this.product.id);
        var response: any = await this.productStore.getProducts();
        var filter = response?.data?.product?.filter(
          (x) => x.id === this.product.id
        );
        if (filter?.length > 0) {
          this.product.wishlist = filter[0]?.wishlist;
        }
        this.loaderService.dismissLoading();
      } catch (error) {
        this.loaderService.dismissLoading();
        this.loaderService.presentToast(
          error.error.data,
          'middle',
          'danger',
          2000
        );
      }
    } else {
      await this.userAuth.requiredLogin();
    }
  }
  showImage(event, product) {
    event?.stopPropagation();
    product.target_audience = 0;
  }
}
